import { createApp } from 'vue';

import Toast from './index.vue';
let instance = null;
let parent = null;
let times = 0;

const close = () => {
  times-=1;
  if (times <= 0) {
    times = 0;
    let appDom = document.getElementById('app');
    instance.unmount(parent);
    appDom.removeChild(parent);
  }
};

const open = (object) => {
  if (times == 0) {
    const message = typeof object === 'string' ? { title: object } : object;
    instance = createApp(Toast);
    instance.config.globalProperties.message = message;
    parent = document.createElement('div');
    let appDom = document.getElementById('app');
    appDom.appendChild(parent);
    instance.mount(parent);
  }
  times+=1;
  setTimeout(() => {
    close();
  }, 2000);
};
export default open;

